var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-line-wrapper",class:{ startAlign: _vm.startAlign }},[_c('div',{staticClass:"title-wrapper"},[_c('h3',{staticClass:"status-title",class:{
        onHold: _vm.status === 'on_hold',
        capitalizeText: _vm.capitalizeText
      }},[_vm._v("\n      Status: "),_c('span',[_vm._v(_vm._s(_vm.statusLabel || _vm.formatKitStatus(_vm.status)))])]),(_vm.reason)?_c('div',{staticClass:"hold-icon"},[_vm._v("\n      ?\n      "),_c('div',{staticClass:"hold_reason"},[_vm._v(_vm._s(_vm.reason))])]):_vm._e()]),(_vm.isLineShown)?_c('div',{staticClass:"status-line"},[_c('div',{staticClass:"line",class:{
        active:
          _vm.status === 'activated' ||
          _vm.status === 'lab_awaiting' ||
          _vm.status === 'lab_received' ||
          _vm.status === 'analysis_completed',
        onHold: _vm.status === 'on_hold'
      }}),_c('div',{staticClass:"line",class:{
        active:
          _vm.status === 'lab_awaiting' ||
          _vm.status === 'lab_received' ||
          _vm.status === 'analysis_completed',
        onHold: _vm.status === 'on_hold'
      }}),_c('div',{staticClass:"line",class:{
        active: _vm.status === 'lab_received' || _vm.status === 'analysis_completed',
        onHold: _vm.status === 'on_hold'
      }}),_c('div',{staticClass:"line",class:{
        active: _vm.status === 'analysis_completed',
        onHold: _vm.status === 'on_hold'
      }})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }